export default __webpack_public_path__ + "static/media/chat-now.c6c5285e.svg";